import { PageLayoutContent } from '@crehana/compass.web/page-layout';

export default function Loading() {
  return (
    <PageLayoutContent className="tw-py-3.2">Loading...</PageLayoutContent>
  );
}
